import { Box, useTheme } from '@mui/material'

export const FormHeaderButton = ({ children, isMergedColumn = false }) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
    <Box
      sx={{
        py: 1.25,
        px: 1,
        height: '100%',
        textAlign: 'center',
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        color: theme.palette.common.white,
        background: isMergedColumn
          ? (theme.palette.newColors?.pinkGradient || theme.palette.success.main)
          : (theme.palette.newColors?.gray || theme.palette.primary.main),
        borderRight: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.2)'}`,
        '&:last-of-type': { borderRight: 'none' },
      }}
    >
      {children}
    </Box>
  )
}
